import script from "./AccountTypeLozenge.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountTypeLozenge.vue?vue&type=script&setup=true&lang=ts"

import "./AccountTypeLozenge.vue?vue&type=style&index=0&id=0f1667dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1667dc"]])

export default __exports__